angular.module('bmsApp.settings')
	.controller('OnlineTermsCtrl', OnlineTermsCtrl);

OnlineTermsCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$timeout',
	'Upload',
	'notify',
	'LicenseOptionsSvc',
	'OnlineTermsSvc',
];

function OnlineTermsCtrl($scope, $state, $q, $timeout, Upload, notify, LicenseOptionsSvc, OnlineTermsSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
		showForm: false,
	});

	self.tinymceOptions = {
		plugins: 'link image preview colorpicker lists',
		elementpath: false,
		statusbar: false,
		menu: {},
		height: "350",
		toolbar: 'bold italic  bullist numlist link  undo redo  preview'
		// toolbar: 'bold italic fontsizeselect forecolor  alignleft aligncenter alignright  bullist numlist link  undo redo  preview'
	};

	this.$onInit = () => {
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.licenseChanged = () => {
		OnlineTermsSvc.read(self.license.id)
			.then((response) => {
				self.term = response.data.term || {};
				self.showForm = true;
			});
	};

	handlers.uploadFiles = (files) => {
		self.uploadInProgress = true;
		let promises = [];
		let file = files[0];
		promises.push(Upload.upload({
			url: 'api/settings/online-term/upload',
			data: {
				file: file
			}
		}));

		$q.all(promises)
			.then(function (responses) {
				angular.forEach(responses, function (response) {
					self.term.file = response.data.file;
				});
				$timeout(function () {
					self.isDragging = false;
					self.uploadInProgress = false;
				});
			}, function (errors) {
				$timeout(function () {
					self.isDragging = false;
					self.uploadInProgress = false;
				});

			});

	};

	handlers.submitClick = function () {
		self.term.license = self.license;
		return OnlineTermsSvc.save(self.term).then((response) => {
			angular.extend(self.term, response.data.term);
			console.log('notify');
			notify({
				message: 'Terms saved',
			});
		}, (errors) => {
			self.errors = errors;
		});
	};
}